import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './Navbar.css';
import drsanti_logo from '../images/drsanti.png';
class Navbar extends Component {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <Link className="navbar-brand" to="/">
          <img src={drsanti_logo} alt="Logo"/>
      </Link>
      <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarNavDropdown">
        <ul className="navbar-nav ml-auto">

          <li className="nav-item ml-auto active">
            <Link className="nav-link" to="/">Home<span className="sr-only" id="homeLink" >(current)</span></Link>
          </li>
          <li className="nav-item ml-auto"><Link className="nav-link" to="/" id="newsLink" >News</Link></li>
          <li className="nav-item ml-auto"><Link className="nav-link" to="/" id="ecclabLink" >ECCLab</Link></li>
          <li className="nav-item ml-auto"><Link className="nav-link" to="/" id="researchLink" >Research</Link></li>
          <li className="nav-item ml-auto"><Link className="nav-link" to="/" id="aboutLink" >About</Link></li>
          <li className="nav-item ml-auto"><Link className="nav-link" to="/" id="contactLink" >Contact</Link></li>
        </ul>
      </div>
    </nav>
    );
  }
};

export default Navbar;
